import React from 'react';
import Title from 'components/TitleWithIcon';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import {useStyles} from './style';
import ComponenteFormulario from './Formulario'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlideDescargarConstanciaDeInscripcionActualizacion(props) {
    const classes = useStyles();
    return (
        <div>
            <Dialog     open={props.open}
                        fullScreen 
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={props.handleClose}
                        aria-labelledby="alert-dialog-slide-title"
                        aria-describedby="alert-dialog-slide-description"
            >
                <Title title={props.titleDialog} icon={"/menu/Document.png"}/>
                <div className={classes.form}>                    
                    <ComponenteFormulario 
                        saveDataDescargarConstancia={props.saveDataDescargarConstancia}
                        handleClose={props.handleClose}
                    />
                </div>
            </Dialog>
        </div>
    );
}